import { crewConstants } from './crew.constants'

const crewState = {
  crew: [],
  loadingCrew: false,
  crewRoles: [],
  loadingCrewRoles: false,
  isFamiliarizedOnBoat: false,
  loadingIsFamiliarizedOnBoat: false,
  familiarizationFormForBoat: {},

  familiarizedAdminUsers: [],
  loadingFamiliarizedAdminUsers: false,

  approvingFamiliarizationForm: false,
}

export function crew(state = crewState, action) {
  switch (action.type) {
    case crewConstants.FETCH_CREW_ROLES_LOADING:
      return {
        ...state,
        loadingCrewRoles: true,
      }
    case crewConstants.FETCH_CREW_ROLES_SUCCESS:
      return {
        ...state,
        loadingCrewRoles: false,
        crewRoles: action.roles,
      }
    case crewConstants.FETCH_CREW_ROLES_ERROR:
      return {
        ...state,
        loadingCrewRoles: false,
      }
    case crewConstants.FETCH_CREW_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingCrew: true,
      }
    case crewConstants.FETCH_CREW_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingCrew: false,
        crew: action.crew,
      }
    case crewConstants.FETCH_CREW_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingCrew: false,
      }
    case crewConstants.IS_USER_FAMILIARIZED_ON_BOAT_LOADING:
      return {
        ...state,
        isFamiliarizedOnBoat: false,
        loadingIsFamiliarizedOnBoat: true,
      }
    case crewConstants.IS_USER_FAMILIARIZED_ON_BOAT_SUCCESS:
      return {
        ...state,
        isFamiliarizedOnBoat: action.isFamiliarized,
        loadingIsFamiliarizedOnBoat: false,
      }
    case crewConstants.FETCH_FAMILIARIZATION_FORM_FOR_BOAT_SUCCESS:
      return {
        ...state,
        familiarizationFormForBoat: action.form,
      }
    case crewConstants.FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_LOADING:
      return {
        ...state,
        loadingFamiliarizedAdminUsers: true,
      }
    case crewConstants.FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_SUCCESS:
      return {
        ...state,
        loadingFamiliarizedAdminUsers: false,
        familiarizedAdminUsers: action.familiarizedAdminUsers,
      }
    case crewConstants.FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_ERROR:
      return {
        ...state,
        loadingFamiliarizedAdminUsers: false,
      }
    case crewConstants.APPROVE_FAMILIARIZATION_ON_BOAT_LOADING:
      return {
        ...state,
        approvingFamiliarizationForm: true,
      }
    case crewConstants.APPROVE_FAMILIARIZATION_ON_BOAT_SUCCESS:
      return {
        ...state,
        approvingFamiliarizationForm: false,
      }
    default:
      return state
  }
}
